import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "A2F Secure", -1)
const _hoisted_2 = { class: "content_form" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  name: "submit"
}, "CONFIRMER", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.a2f_verif && _ctx.a2f_verif(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "number",
          name: "mail_code",
          placeholder: "MAIL code",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code.mail) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.code.mail]
        ]),
        _withDirectives(_createElementVNode("input", {
          type: "number",
          name: "totp_code",
          placeholder: "TOTP code",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.code.totp) = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, _ctx.code.totp]
        ]),
        _hoisted_3
      ])
    ], 32)
  ], 64))
}